import EventEmitter from 'src/helpers/EventEmitter'
import { DEG_TO_RAD } from 'src/helpers/MathUtils'
import { frequencies } from 'src/helpers/WebAudio'
import store from '@/store';

import Bg from 'src/components/Stage/question/bg'
import ProcessingCircles from 'src/components/Stage/question/circles';
import Character from 'src/components/Stage/question/character';
import Timer from 'src/components/Stage/question/timer'
import ResizeService from '@/services/ResizeService' 
const THREE = require('three')
 
class Questions extends THREE.Group { 

  constructor(config) {

    super();

    Object.assign(this, EventEmitter)

    this.materials = config.materials;
    this.STATES = store.state.question.STATES;
    this.state = null;
    this.frequencyData = null;

    this.position.y = 50;
    this.position.z = -250;
    this.scale.x = this.scale.y = this.scale.z = 1.1;

    this.setup();
    this.resize();
  }

  setup() { 
 
    for (var i = 0; i < 64; i++) {
      let rect = new THREE.PlaneBufferGeometry( 30 + (15 * Math.random()), 50 + (10 * Math.random())) 
      let inner = new THREE.Group();
     
      let material = this.materials[Math.round(Math.random() * 3)];  
      let mesh = new THREE.Mesh(rect, material);

      mesh.randomVel = 0.3 + (Math.random() * 0.8);
      mesh.scale.y = 0.015;
      mesh.position.z = -i;
      inner.rotation.z = Math.random() * 360 * DEG_TO_RAD;
      inner.add(mesh)
      this.add( inner)
    } 
  } 

  tick(tap_hold_ratio) {

    if(
      this.state === this.STATES.TAP_HOLD_PROGRESS || 
      this.state === this.STATES.TAP_HOLD_RECORD || 
      this.state === this.STATES.TAP_HOLD_RELEASE 
    ){ 

      let intensity = 1.1;
      for (var i = 0; i < this.children.length; i++) {

        let group = this.children[i];
        let child = group.children[0]; 
        let tgy = tap_hold_ratio * child.randomVel * window.innerWidth;
       
        if(frequencies){
          //let index = Math.round(frequencies.length / this.lines.children.length * i ) ;
          tgy += (frequencies[i  * 2] * intensity * tap_hold_ratio); 
        }

        child.position.y += (tgy - child.position.y) * 0.4; 
        child.scale.y  = (window.Power2.easeOut.getRatio( tap_hold_ratio) * ( 3 + child.randomVel) ) + 0.001;
      }
    } 
  }

  updateRoute(val) {}

  idle() {
    this.visible = false;
    for (var i = 0; i < this.children.length; i++) { 
      this.children[i].rotation.z = Math.random() * 360 * DEG_TO_RAD; 
    }
  }

  tapholdProgress() {
    this.visible = true;
  }
  
  tapholdRecord() {}

  tapholdRelease() {}
    
  processing() {}
    
  complete() {
    for (var i = 0; i < this.children.length; i++) { 
      let group = this.children[i];
      let child = group.children[0]; 
      TweenMax.to(child.position, 1, {
        y: 0
      });
      TweenMax.to(child.scale, 1, {
        y: 0.01
      });
    }
    TweenMax.delayedCall(1, this.onCompleteComplete);
  }

  onCompleteComplete = () => {
    this.visible = false;
  }

  result(val){}
  
  updateRoute(val) {}

  updateState(val){
    this.state = val;
  }
   
  resize = () => {}

}

export default Questions